import React, { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotificationAlert from "react-notification-alert";

import {
  get_accounts,
  get_accounts_totp,
  get_accounts_kyc,
  put_accounts,
  post_accounts_auth,
  post_accounts_auth_code,
  put_accounts_security,
  delete_accounts,
  delete_accounts_delete,
  post_accounts_images,
  delete_accounts_images_id,
} from "stores/Accounts/actions";

import SettingsView from "./SettingsView";
import LoadingView from "../../modules/Loading/LoadingView";
import { getMessage } from "config/util";

const App = ({ nonce }) => {
  const dispatch = useDispatch();
  const ref = useRef();

  const toast = (error) => {
    const message = getMessage(error);
    dispatch_danger(message);
  };

  const dispatch_info = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-bell-55" />
            <span>{message}</span>
          </div>
        ),
        type: "info",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_danger = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-single-copy-04" />
            <span>{message}</span>
          </div>
        ),
        type: "danger",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_post_accounts_auth = (data, page) => {
    dispatch(
      post_accounts_auth({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_post_accounts_auth_code = (data, page) => {
    dispatch(
      post_accounts_auth_code({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_put_accounts_security = (data, page) => {
    dispatch(
      put_accounts_security({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_accounts = (data, page) => {
    dispatch(
      get_accounts({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_accounts_totp = (data, page) => {
    dispatch(
      get_accounts_totp({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_get_accounts_kyc = (data, page) => {
    dispatch(
      get_accounts_kyc({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_put_accounts = (data, page) => {
    dispatch(
      put_accounts({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_delete_accounts = (data, page) => {
    dispatch(
      delete_accounts({
        data,
        toast,
        page,
      })
    );
  };
  const dispatch_delete_accounts_delete = (data, page) => {
    dispatch(
      delete_accounts_delete({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_post_accounts_images = (data, page) => {
    dispatch(
      post_accounts_images({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_delete_accounts_images_id = (data, page) => {
    dispatch(
      delete_accounts_images_id({
        data,
        toast,
        page,
      })
    );
  };

  useEffect(() => {
    dispatch_get_accounts({}, () => {});
  }, [nonce]);

  const reduce_get_maps = useSelector((state) => state.reduce_get_maps);
  const reduce_get_accounts = useSelector((state) => state.reduce_get_accounts);
  const reduce_get_accounts_kyc = useSelector(
    (state) => state.reduce_get_accounts_kyc
  );

  if (reduce_get_accounts.isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <div className="notification-container">
        <NotificationAlert ref={ref} />
      </div>

      <SettingsView
        maps={reduce_get_maps}
        accounts={reduce_get_accounts}
        kyc={reduce_get_accounts_kyc.kyc}
        dispatch_info={dispatch_info}
        dispatch_danger={dispatch_danger}
        dispatch_get_accounts_kyc={dispatch_get_accounts_kyc}
        dispatch_get_accounts_totp={dispatch_get_accounts_totp}
        dispatch_put_accounts={dispatch_put_accounts}
        dispatch_post_accounts_auth={dispatch_post_accounts_auth}
        dispatch_post_accounts_auth_code={dispatch_post_accounts_auth_code}
        dispatch_put_accounts_security={dispatch_put_accounts_security}
        dispatch_get_accounts={dispatch_get_accounts}
        dispatch_delete_accounts={dispatch_delete_accounts}
        dispatch_delete_accounts_delete={dispatch_delete_accounts_delete}
        dispatch_post_accounts_images={dispatch_post_accounts_images}
        dispatch_delete_accounts_images_id={dispatch_delete_accounts_images_id}
      />
    </>
  );
};

export default App;
